module.exports = __webpack_public_path__ + "static/media/RejectIcon.9a63a4da.svg";